var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "calculator" }, [
      _c("div", { staticClass: "display prev" }, [
        _vm._v(
          _vm._s(_vm.calculator.previous || "") +
            " " +
            _vm._s(_vm.calculator.sign)
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "display result" }, [
        _vm._v(_vm._s(_vm.calculator.current || "0"))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn operator clear", on: { click: _vm.clearAll } },
        [_vm._v("C")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn operator", on: { click: _vm.division } }, [
        _vm._v("/")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("7")
            }
          }
        },
        [_vm._v("7")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("8")
            }
          }
        },
        [_vm._v("8")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("9")
            }
          }
        },
        [_vm._v("9")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn operator", on: { click: _vm.multiplication } },
        [_vm._v("*")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("4")
            }
          }
        },
        [_vm._v("4")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("5")
            }
          }
        },
        [_vm._v("5")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("6")
            }
          }
        },
        [_vm._v("6")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn operator", on: { click: _vm.subtraction } },
        [_vm._v("-")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("1")
            }
          }
        },
        [_vm._v("1")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("2")
            }
          }
        },
        [_vm._v("2")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("3")
            }
          }
        },
        [_vm._v("3")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn operator", on: { click: _vm.sum } }, [
        _vm._v("+")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.append("0")
            }
          }
        },
        [_vm._v("0")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn" }),
      _vm._v(" "),
      _c("div", { staticClass: "btn operator", on: { click: _vm.equal } }, [
        _vm._v("=")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }